import { styled } from 'linaria/react';

import { FONTS, COLORS } from '../../styles/constants';

const StyledWrap = styled.div<{ isDark: boolean }>`
  z-index: 0;
  position: relative;
  margin: 0 auto;
  font-family: ${FONTS.primary};
  font-size: 16px;
  color: ${({ isDark }) => (isDark ? COLORS.white[100] : COLORS.brown.dark[100])};
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  background: ${({ isDark }) =>
    isDark
      ? 'linear-gradient(180deg, #331500 0%, #141400 10%, #141400 90%, #0A0033 100%)'
      : 'linear-gradient(180deg, #FFEEE8 0%, #F7F6F3 10%, #F7F6F3 90%, #ECE8FF 100%), #FFF'};
`;

export const StyledVirtualBg = styled.div<{ isDark?: boolean; isDiscovery?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  background: ${({ isDark, isDiscovery }) => {
    if (isDiscovery) {
      return isDark
        ? 'linear-gradient(180deg, #331500 0%, #141400 10%, #141400 90%, #0A0033 100%)'
        : 'linear-gradient(180deg, #FFEEE8 0%, #F7F6F3 10%, #F7F6F3 90%, #ECE8FF 100%), #FFF';
    }
    return isDark ? '#141400' : '#F7F6F3';
  }};
  z-index: -1;
  user-select: none;
  pointer-events: none;
`;

export const MainContent = styled.main<{ isDiscovery?: boolean }>`
  padding-top: ${({ isDiscovery }) =>
    isDiscovery ? '104px' : '0'}; // 56px Navigation + 48px ExploreTabs for Discovery only
`;

export default StyledWrap;
